export const LOGIN = "LOGIN"
export const LOG_OUT = "LOG_OUT"
export const USER_DATA = "USER_DATA"
export const SETTING = "SETTING"
